import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguageContext } from '@/i18n/LanguageContext';

// Mobile-only fixed bottom CTA bar. Slides in once the visitor scrolls past
// the hero (matches the FR production reference pattern). Hidden on md+.
export default function MobileFixedCTA() {
  const [visible, setVisible] = useState(false);
  const { t } = useTranslation();
  const { lang } = useLanguageContext();
  const location = useLocation();

  const href = (path: string) =>
    lang === 'en' ? (path === '/' ? '/en' : `/en${path}`) : path;

  useEffect(() => {
    const handleScroll = () => {
      setVisible(window.scrollY > 500);
    };
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  // Re-evaluate on route change so the bar doesn't stay stuck open/closed
  // from the previous page's scroll position.
  useEffect(() => {
    setVisible(window.scrollY > 500);
  }, [location.pathname]);

  return (
    <div
      className={`md:hidden fixed bottom-0 left-0 right-0 z-40 h-14 bg-primary-950 border-t border-accent-500/40 transition-transform duration-300 ${
        visible ? 'translate-y-0' : 'translate-y-full'
      }`}
    >
      <div className="h-full px-4 flex items-center justify-between gap-3">
        <span className="text-accent-400 text-[13px] tracking-[0.15em] font-heading shrink-0">
          {t('common.mobileCta.brand')}
        </span>
        <div className="flex items-center gap-2">
          <Link
            to={href('/brochure')}
            className="px-3.5 py-2 bg-accent-500 text-primary-900 text-[12px] tracking-[0.05em] font-medium whitespace-nowrap"
          >
            {t('common.mobileCta.brochure')}
          </Link>
          <Link
            to={href('/apply')}
            className="px-3.5 py-2 bg-primary-800 border border-accent-500 text-accent-400 text-[12px] tracking-[0.05em] whitespace-nowrap"
          >
            {t('common.mobileCta.apply')}
          </Link>
        </div>
      </div>
    </div>
  );
}
